import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Image, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {useCommerceAPI} from '../../commerce-api/contexts'
import useAsync from '../../commerce-api/hooks/useAsync'
import {capitalize} from '../../utils/utils'

const WidgetStoreTile = ({id, color, showImages, variant}) => {
    const styles = useMultiStyleConfig('Stores', {variant})
    const api = useCommerceAPI()
    const colorWorld = `stokke${capitalize(color || 'gray')}.bright`

    const {
        error,
        data: store,
        execute
    } = useAsync(async (id) => {
        return await api.shopperStore.getStore({parameters: {id}})
    })

    useEffect(() => {
        if (id) {
            execute(id)
        }
    }, [execute, id])

    useEffect(() => {
        if (error) {
            console.error('A error occurred while loading store with id ', id, error)
        }
    }, [id, error])

    return (
        <Flex {...styles.flexContainer} backgroundColor={colorWorld}>
            <Flex {...styles.alignment}>
                {!!store?.name && <Text {...styles.text}>{store.name}</Text>}
                {!!store?.address1 && <Text {...styles.text}>{store.address1}</Text>}
                <Text {...styles.text}>
                    {!!store?.city && store.city}
                    {!!store?.city && !!store?.postalCode && ' '}
                    {!!store?.postalCode && store.postalCode}
                </Text>
            </Flex>
            {showImages &&
                (store?.image ? (
                    <Image {...styles.image} src={store.image} loading="lazy" />
                ) : (
                    <Box {...styles.image}></Box>
                ))}
        </Flex>
    )
}

WidgetStoreTile.propTypes = {
    id: PropTypes.string,
    color: PropTypes.string,
    showImages: PropTypes.bool,
    variant: PropTypes.string
}

export default WidgetStoreTile
